import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/app/App'
import { initI18n } from '@/i18n'
import '@/ui/global.css'

/**
 * Точка входа. Порядок: i18n → (опционально) mock-слой → рендер.
 *
 * `import.meta.env.VITE_USE_MOCKS` подставляется Vite как строковый литерал
 * (см. `vite.config.ts`), поэтому в прод-сборке условие вычисляется статически
 * и весь `@/mocks` вырезается вместе с `msw`.
 */

async function bootstrap(): Promise<void> {
  initI18n()

  if (import.meta.env.VITE_USE_MOCKS === '1') {
    const { startMocks } = await import('@/mocks')
    await startMocks()
  }

  const container = document.getElementById('root')
  if (!container) throw new Error('#root не найден в index.html')

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>
  )
}

void bootstrap()
